import React from 'react';
import { Callout, DocHeading, DocTable, Shot } from './components';

function PageNames() {
  return (
    <div>
      <h1 className="text-[2.5rem] leading-[1.1] font-semibold text-white tracking-[-0.02em] mb-3">Names</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Show another name for your character, color the name above your head, or hide names
        altogether &mdash; useful for screenshots, videos and streams. Everything changes live,
        without a map reload. Everything is on{' '}
        <strong className="text-white">VISUALS &rsaquo; Names</strong>.
      </p>

      <Callout type="info">
        All of this is <strong>only on your screen</strong>. Other players still see your real
        name, and nothing is sent to the server.
      </Callout>

      <Shot
        name="names-01-names-tab.png"
        tab="VISUALS › Names"
        caption="A custom name in gold, and the name above your own head hidden."
        shoot="menushot (stage names): Custom name BE „MortisEngine”, Name color BE #FFD700, Hide my own name BE."
      />

      <DocHeading>My Name</DocHeading>
      <DocTable
        headers={['Switch', 'What it does']}
        rows={[
          [<strong className="text-white">Custom name</strong>, 'Switch it on and type. The name changes above your head, in the inventory headline, on the character sheet and in the kill messages. Chat lines are not changed.'],
          [<strong className="text-white">Name color</strong>, 'Pick any color for the name above your head. When the game redraws the name (a death, a map load), the bot puts the color back a moment later.'],
        ]}
      />
      <DocTable
        headers={['Message', 'What it means']}
        rows={[
          [<span className="text-amber-300">Empty - your real name is shown.</span>, 'The box is empty. Type a name.'],
          [<span className="text-amber-300">Too long (N), the field holds M.</span>, 'The game reserved room for M letters. Use a shorter name.'],
          [<span className="text-amber-300">Name field not found - nothing is written.</span>, 'Your character is not fully loaded yet. It fixes itself.'],
          [<span className="text-amber-300">The name above your head is not found yet.</span>, 'Same, for the color.'],
        ]}
      />

      <DocHeading>Hide Names</DocHeading>
      <DocTable
        headers={['Switch', 'What it does']}
        rows={[
          [<strong className="text-white">Hide all player names</strong>, 'Every name above a player’s head, yours included. It is the game’s own setting, switched for you.'],
          [<strong className="text-white">Hide my own name</strong>, 'Only the name above your own head.'],
        ]}
      />
      <p className="text-sm text-gray-400 mb-4">
        Both work instantly, and the names come back as soon as the bot unloads. The card says{' '}
        <em>Waiting for the game settings.</em> until the game has loaded them.
      </p>
      <Callout type="warning">
        The game saves these two to its own <strong>settings.xml</strong>. If the game crashes while
        names are hidden, they can stay hidden &mdash; switch them back on here, or in the game&rsquo;s
        own options.
      </Callout>
    </div>
  );
}

export default PageNames;
